import { render, staticRenderFns } from "./AccountsHistoryView.vue?vue&type=template&id=227ade19&"
import script from "./AccountsHistoryView.vue?vue&type=script&lang=js&"
export * from "./AccountsHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports